<template>
  <ValidationObserver v-slot="{ invalid }">

    <vx-card>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <ValidationProvider v-slot="{ errors }" :name="$t('reset-password.user-name')" rules="required">
            <vs-input v-model="userName" :description-text="$t('reset-password.reset-to')"
                      :label="$t('reset-password.user-name') + ' *'"
                      class="w-full"/>
            <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
    </vx-card>

    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row">
      <div class="vx-col w-full mt-3">
        <vs-button :disabled="processing || invalid " class="ml-2" color="primary"
                   @click.prevent="handlerResetPasswordClick">
          {{ $t('general.save') }}
        </vs-button>
      </div>
    </div>

  </ValidationObserver>
</template>

<script>
import {showLocalNotification, notificationType, showStateNotification} from "@/utils/notification";
import {createNamespacedHelpers} from "vuex";
import {createHelpers} from "vuex-map-fields";
import store from "@/store";
import user from "@/store/modules/user";

if (!store.state.user) store.registerModule(`user`, user);

const {mapFields: mapUserFields} = createHelpers({
  getterType: `user/getField`,
  mutationType: `user/updateField`,
});

const {
  mapActions: mapUserActions,
} = createNamespacedHelpers(`user`);


export default {
  name: "index",
  data() {
    return {
      userName: ''
    };
  },
  computed: {
    ...mapUserFields(["processing", "error"]),
  },
  watch: {
    error: async function (data) {
      showStateNotification(this.$vs, data);
    },
  },
  methods: {
    ...mapUserActions({
      resetPasswordByAdmin: 'resetPasswordByAdmin',
    }),
    async handlerResetPasswordClick() {
      const payload = {
        username: this.userName,
        newPassword: this.userName,
      };

      const result = await this.resetPasswordByAdmin(payload);

      if (result && !result.error) {
        showLocalNotification(this.$vs,
          this.$t('general.success'),
          this.$t('reset-password.reset-success'),
          notificationType.SUCCESS);
        this.userName = '';
      } else {
        showLocalNotification(this.$vs,
          this.$t('general.error'),
          result.message,
          notificationType.ERROR);
      }
    }
  }
}
</script>

<style scoped>

</style>
